import Vue from 'vue'
import request from 'axios'
import { decode } from 'lib/util'
import 'modules/simple-product-card/simple-product-card.vue'
import state from 'lib/appState'

Vue.component('cart-related-products', {
  data () {
    return {
      products: [],
      isLoaded: true,
      state
    }
  },
  watch: {
    'state.cart.items': function () {
      this.fetchProducts()
    }
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    async fetchProducts () {
      try {
        const { data } = await request.get('/cart', {
          params: {
            view: 'recommendations'
          }
        })
        this.isLoaded = true
        const { results = [] } = JSON.parse(decode(data))
        if (results.length > 2) {
          this.products = results.slice(0, 2)
        } else {
          this.products = results
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
})
